module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/suplido/suplido.component.css
// module id = ./src/app/components/suplido/suplido.component.css
// module chunks = main